function insertAfter(e,n){n.nextSibling?n.parentNode.insertBefore(e,n.nextSibling):n.parentNode.appendChild(e)}